interface User {
  id: number
  name: string
  username: string
  email: string
  avatar: string
  bio?: string
  accountType?: "personal" | "business"
  business?: {
    name: string
    cif: string
    commercialRegistryNumber: string
    address: string
  }
  createdAt: string
}

export async function login(email: string, password: string): Promise<User | null> {
  const normalizedEmail = email.trim().toLowerCase()
  try {
    const response = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: normalizedEmail, password }),
    })

    if (response.ok) {
      const user = await response.json()
      if (typeof window !== "undefined") {
        localStorage.setItem("currentUser", JSON.stringify(user))
        localStorage.setItem("sessionExpiry", String(Date.now() + 7 * 24 * 60 * 60 * 1000))
      }
      return user
    }
  } catch (err) {
    console.error("[v0] Login API error:", err)
  }

  return null
}

export async function register(payload: {
  name: string
  username: string
  email: string
  password: string
  accountType: "personal" | "business"
  businessName?: string
  cif?: string
  commercialRegistryNumber?: string
  businessAddress?: string
}): Promise<User | null> {
  try {
    const response = await fetch("/api/auth/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })

    if (response.ok) {
      const user = await response.json()
      if (typeof window !== "undefined") {
        localStorage.setItem("currentUser", JSON.stringify(user))
        localStorage.setItem("sessionExpiry", String(Date.now() + 7 * 24 * 60 * 60 * 1000))
      }
      return user
    }
  } catch (err) {
    console.error("[v0] Register API error:", err)
  }

  return null
}

export function logout(): void {
  if (typeof window !== "undefined") {
    localStorage.removeItem("currentUser")
    localStorage.removeItem("sessionExpiry")
    // Clear all cached data
    const keys = Object.keys(localStorage)
    keys.forEach((key) => {
      if (key.startsWith("messages_") || key.startsWith("cache_")) {
        localStorage.removeItem(key)
      }
    })
  }
}

export function getCurrentUser(): User | null {
  if (typeof window === "undefined") return null

  const userStr = localStorage.getItem("currentUser")
  const expiry = localStorage.getItem("sessionExpiry")

  if (!userStr || !expiry) return null

  // Check if session expired
  if (Date.now() > Number(expiry)) {
    logout()
    return null
  }

  try {
    return JSON.parse(userStr)
  } catch {
    return null
  }
}

export function updateCurrentUser(user: User): void {
  if (typeof window === "undefined") return
  localStorage.setItem("currentUser", JSON.stringify(user))
  localStorage.setItem("sessionExpiry", String(Date.now() + 7 * 24 * 60 * 60 * 1000))
}

export function isAuthenticated(): boolean {
  return getCurrentUser() !== null
}
